// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as OnboardingTemplate from "./OnboardingTemplate.bs.jsx";

function get(state, field) {
  return state.name;
}

function set(_state, field, value) {
  return {
    name: value
  };
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function OnboardingNickName(props) {
  let onSubmit = props.onSubmit;
  let form = Form.use({
    name: props.initialName
  }, Validators$1.schema([Validators$1.required("Name")]), param => {
    let raiseSubmitFailed = param.raiseSubmitFailed;
    Stdlib_Promise.$$catch(onSubmit(param.state.values), error => {
      let errorMessage;
      if (error.RE_EXN_ID === "JsExn") {
        let msg = Stdlib_JsExn.message(error._1);
        errorMessage = msg !== undefined ? `Chyba: ` + msg : "Neznámá chyba";
      } else {
        errorMessage = "Neznámá chyba";
      }
      raiseSubmitFailed(errorMessage);
      return Promise.resolve();
    });
  }, undefined, undefined, "OnDemand", undefined);
  let maybeErrorMessage = form.state.formState;
  let tmp;
  if (typeof maybeErrorMessage !== "object") {
    tmp = null;
  } else {
    let maybeErrorMessage$1 = maybeErrorMessage._0;
    tmp = maybeErrorMessage$1 !== undefined ? maybeErrorMessage$1 : "Neznámá chyba";
  }
  return <OnboardingTemplate.make>
    <h2>
      {"Jak ti říkají?"}
    </h2>
    <Form.Provider.make
      value={form}
    >
      <form
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={`reset ` + Styles.fieldset.grid}
        >
          <p
            className={Styles.fieldset.gridSpan}
          >
            {`Tvoje přezdívka se použije pro místa, která založíš.`}
          </p>
          <p
            className={Styles.fieldset.gridSpan}
          >
            {`Tam, kde jsi hostem můžeš mít jiné jméno, to určuje správce každého místa.`}
          </p>
          <Form.Field.make
            field={"Name"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"name"}
              inputSlot={<input
                autoComplete={"name"}
                type={"text"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={`Přezdívka`}
            />}
          />
          <button
            className={Styles.button.base + ` ` + Styles.fieldset.gridSpan}
            type={"submit"}
          >
            {`Dokončit registraci`}
          </button>
        </fieldset>
      </form>
      {tmp}
    </Form.Provider.make>
  </OnboardingTemplate.make>;
}

let make = OnboardingNickName;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
